import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

class DataIngestion {
  static ENDPOINT = 'api/v2/run-v2';

  static async uploadData(dealerId: string, formData: FormData): Promise<APIResponseType> {
    try {
      const response = await apiService.post<APIResponseType>(
        `${this.ENDPOINT}?dealer_id=${dealerId}`,
        formData
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getUploads(dealerId: string, params?: any): Promise<APIResponseType> {
    try {
      const response = await apiService.get<APIResponseType>(
        `${this.ENDPOINT}/uploads?dealer=${dealerId}`,
        params
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getUploadStatus(uploadId: string): Promise<APIResponseType> {
    try {
      const response = await apiService.get<APIResponseType>(
        `${this.ENDPOINT}/uploads/${uploadId}/status`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default DataIngestion; 